module.exports = __webpack_public_path__ + "static/media/linkedin.bf592d59.svg";